<template>

  <div id="login" class="login">
    <div class="logo-waveBox">
        <div class="wave wave-Circle">
        </div>
        <div class="wave wave-Horizontal-1"></div>
        <div class="wave wave-Vertical-2"></div>
        <div class="wave wave-Horizontal-2"></div>
    </div>
    <div id="login" class="loginPage">
      <div class="loginBox" v-bind:class=" $root.is_mobile ? 'loginBox-m': ''">
        <el-row  class="Hlogo m-t16">
            <el-image :src= titleCheckData.HlogoURL class="Hlogoimg" alt="医院LOGO">
              <div slot="error">
                <el-image :src= imgzologo  alt="微影" style="    height: 98px;    width: 100px;" />
              </div>
            </el-image>
        </el-row>
        <el-row class="m8 " ><b class="report-title">请选择登录模式</b></el-row>
        <div class="form-box"><!-- 上下动态调整位置 需要DIV---->
          <div class="p16 p-b32" 
                  style="    border-radius: 4px;">
            <el-button round  type="primary" style=" margin: 8px;   width: 100%;" v-on:click="login_doctor()">医生端登录</el-button>
            <!-- <el-button round  type="primary" style=" margin: 8px;   width: 100%;" v-on:click="login_appoint()">预约平台登录</el-button> -->
            <el-button round  type="success" style=" margin: 8px;   width: 100%;" v-on:click="login_admin()">管理员登录</el-button>
            <!-- <el-button round  type="warning" style=" margin: 8px;   width: 100%;" v-on:click="login_partner()">伙伴登录</el-button> -->
          </div>
        </div>
      </div>
    </div>
    <copyright />
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/index.css'; // the theme changed version element-ui css

import Element from 'element-ui'
import Vue from 'vue'
Vue.use(Element, {
  //size: Cookies.get('size') || 'medium', // set element-ui default size
})
import copyright from "@/components/imgzo_copyright.vue"

export default {
  name: "report",
  data() {
    return {
      copyright_year:2022,
      imgzologo:require('@/assets/logo/logo_pic-text.svg'),
      titleCheckData:{
        HlogoURL:'',
      },
    HospitalID:'',
    };  
  },
  props:{  },
  mounted() {
    this.IsMobile();
    let nowDate = new Date();
    this.copyright_year = nowDate.getFullYear(); //获取完整的年份(4位,1970-????)
    this.HospitalID = this.$route.query.Hid;//获取地址中的患者HospitalID
    if (this.HospitalID != undefined) {
      // 根据医院ID 直接获取LOGO文件
      this.titleCheckData.HlogoURL = `/logo/${this.HospitalID}/logo_svg.svg`;
    } else this.titleCheckData.HlogoURL = require('@/assets/logo/logo_pic-text.svg');
  },
  methods: {
    login_doctor() {
      window.open("https://doc.imgzo.cn/#/login", "_self");
    },
    login_appoint() {
      window.open("https://appoint.imgzo.cn/#/login?pageName=docIndexPage", "_self");
    },
    login_admin() {
      window.open("https://admin.imgzo.cn/#/login", "_self");
    },
    login_partner() {
      window.open("https://admin.imgzo.cn/#/login?pageName=padminIndexPage", "_self");
    },
    IsMobile() {
      //判断是否手机端访问
      //let userAgentInfo = navigator.userAgent.toLowerCase();
      let sUserAgent = navigator.userAgent.toLowerCase();
      let bIsIpad = sUserAgent.match(/ipad/i) == 'ipad';
      let bIsIphone = sUserAgent.match(/iphone os/i) == 'iphone os';
      let bIsMidp = sUserAgent.match(/midp/i) == 'midp';
      let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4';
      let bIsUc = sUserAgent.match(/ucweb/i) == 'web';
      let bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce';
      let bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile';
      let bIsAndroid = sUserAgent.match(/android/i) == 'android';
      let userAgent ="";
      //alert(sUserAgent); 
      //iphone:mozilla/5.0 (iphone; cpu iphone os 11_0 like mac os x) applewebkit/604.1.38 (khtml, like gecko) version/11.0 mobile/15a372 safari/604.1
      //galaxy:mozilla/5.0 (linux; android 5.0; sm-g900p build/lrx21t) applewebkit/537.36 (khtml, like gecko) chrome/79.0.3945.88 mobile safari/537.36
      //ipad: mozilla/5.0 (ipad; cpu os 11_0 like mac os x) applewebkit/604.1.34 (khtml, like gecko) version/11.0 mobile/15a5341f safari/604.1
      //Pixel2: mozilla/5.0 (linux; android 8.0; pixel 2 build/opd3.170816.012) applewebkit/537.36 (khtml, like gecko) chrome/79.0.3945.88 mobile safari/537.36 
      if( bIsIphone || bIsMidp || bIsUc7 || bIsUc || bIsCE || bIsWM || bIsAndroid || bIsIpad){
        this.is_mobile = true;
        this.$root.is_mobile= true;
      }
    }
  },
    components: {
      copyright
  }
};
</script>

<style>
.login {
  overflow: hidden;
}
.login .loginPage {
    width: 100vw;
    height: 100vh;
    background-color: var(--WhiteColor-2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.login .loginPage .loginBox {    
  position: absolute;
    /* top: 16%; */
    /* left: 16%; */
    width: 50%;
    min-width: 360px;
    max-width: 580px;
    display: flex;
    background-color: var(--WhiteColor-2);
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
}
.login .loginPage .loginBox-m {
    color: var(--BlackColor-2);
    background: none
}
.login .loginPage .login-choose {
  font-size: 14px;
  color: var(--BlackColor-2);
  text-align: center;
}

.login .loginPage .Hlogoimg {
  height: 98px;
    width: 100px;
    border: 19px solid var(--PrimaryColor-10);
    border-radius: 50%;
    box-shadow: 0px 0px 8px 4px var(--PrimaryColor-1);
    background: var(--WhiteColor-1);
}
.login .logo-waveBox {
  position: absolute;height: 100%;width: 100%;overflow: hidden;
  --backgroundWaveTop: 19.1vh;
  --backgroundWaveLeft:calc((100vw - var(--backgroundWaveWidth)) / 2);
  --backgroundWaveWidth: 110vw;
  }

.login .logo-waveBox .wave {
    position: absolute;
    border-radius: 50% 50% 0 0;
    mix-blend-mode: multiply;
    overflow: hidden;
}
.login .wave-Circle {
    top: calc(var(--backgroundWaveTop) );
    left: var(--backgroundWaveLeft);
    width: var(--backgroundWaveWidth);
    height: var(--backgroundWaveWidth);
    background-color: var(--PrimaryColor-10);
}
.login .wave-Horizontal-1  {
    top: calc(var(--backgroundWaveTop)  + var(--backgroundWaveWidth) * 0.06798);
    left: var(--backgroundWaveLeft);
    width: var(--backgroundWaveWidth);
    height: calc(var(--backgroundWaveWidth) * 0.86403);
    background-color: var(--PrimaryColor-10);
}
.login .wave-Vertical-1   {
    top: calc(var(--backgroundWaveTop) );
    left: calc(var(--backgroundWaveWidth) * 0.3876);
    width: calc(var(--backgroundWaveWidth) * 0.92249);
    height: var(--backgroundWaveWidth);
    background-color: #fff;
    border: 1px solid var(--SecondColor-10);
}
.login .wave-Vertical-2{
    top: calc(var(--backgroundWaveTop) );
    left: calc(var(--backgroundWaveLeft) + var(--backgroundWaveWidth) * 0.10147);
    width: calc(var(--backgroundWaveWidth) * 0.79706);
    height: var(--backgroundWaveWidth);
    background-color: var(--PrimaryColor-10);
}
.login .wave-Horizontal-2   {
    top: calc(var(--backgroundWaveTop)  + var(--backgroundWaveWidth) * 0.17799);
    left: var(--backgroundWaveLeft);
    width: var(--backgroundWaveWidth);
    height: calc(var(--backgroundWaveWidth) * 0.64403);
    background-color: var(--PrimaryColor-10);
}
.login .wave-Vertical-3 {
    top: calc(var(--backgroundWaveTop) );
    left: calc(var(--backgroundWaveWidth) * 0.20295);
    width: calc(var(--backgroundWaveWidth) * 0.59411);
    height: var(--backgroundWaveWidth);
    background-color: var(--PrimaryColor-10);
    border: 1px solid var(--SecondColor-10);
}
.login .wave-Vertical-4 {
    top: calc(var(--backgroundWaveTop) );
    left: calc(var(--backgroundWaveWidth) * 0.36715);
    width: calc(var(--backgroundWaveWidth) * 0.26570);
    height: var(--backgroundWaveWidth);
    background-color: var(--PrimaryColor-10);
    border: 1px solid var(--SecondColor-10);
}
/* .login .logo-waveBox .wave {
    position: absolute;
    background-color: var(--PrimaryColor-10);
    border-radius: 50%;
    mix-blend-mode: multiply;
    overflow: hidden;
}
.login .wave-Circle {
    top: var(--backgroundWaveTop);
    left: -25vw;
    width: 150vw;
    height: 150vw;
}
.login .wave-Horizontal-1  {
    top: calc(10.94vw + var(--backgroundWaveTop));
    left: -25vw;
    width: 150vw;
    height: 128.12vw;
}
.login .wave-Vertical-2{
    top: var(--backgroundWaveTop);
    left: -7.3vw;
    width: 114.6vw;
    height: 150vw;
}
.login .wave-Horizontal-2   {
    top: calc(28.64vw + var(--backgroundWaveTop));
    left: -25vw;
    width: 150vw;
    height: 92.71vw;
} */

</style>